import React, { Component } from 'react';


class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      isPlaying: false,
    };
  }

  handlePlay = () => {
    this.videoRef.current.play();
    this.setState({ isPlaying: true });
  };

  handlePause = () => {
    this.setState({ isPlaying: false });
  };

  render() {
    const { src, poster } = this.props;
    return (
      <div className="video_placeholder mb-none">
        <video
          ref={this.videoRef}
          onPlay={() => this.setState({ isPlaying: true })}
          onPause={this.handlePause}
          controls
          src={src}
          type="video/mp4"
          poster={poster}
        />
        {!this.state.isPlaying && (
          <div
            className="video_play blue_gradient hover_dark"
            onClick={this.handlePlay}
          ></div>
        )}
      </div>
    );
  }
}

export default VideoPlayer;
